<template>
  <div class="auth-login">
    <!-- enter code -->
    <form
      class="form"
      action=""
      v-on:submit.prevent="sendCode"
      v-if="codePending"
    >
      <div class="form__fields">
        <h1 v-html="'Введите 4&nbsp;цифры'"></h1>

        <!-- <p>
          Введите 4 последние цифры номера,<br>
          который вам только что позвонил.<br>
          Эти цифры и есть welcome-код.
        </p> -->

        <div class="form-input__wrapper">
          <code-box
            v-bind:charCount="codeDigits"
            v-bind:readonly="isLoading"
            v-bind:autosend="autosendCode"
            v-on:fullCode="sendCode"
            v-model="form.code" />
        </div>

        <p>
          <a
            class="info-link"
            href="#"
            v-on:click.prevent="codePending = false"
          >
            <i class="icon icon__info"></i>
            <span>Прошло 5 минут, а кода всё нет?</span>
          </a>
        </p>
      </div>

      <div class="form__controls">
        <span
          class="ajax-loading"
          v-if="isLoading"
        ></span>
        <button
          v-else
          class="dark button"
          v-bind:class="{ inactive: !validCode }"
        >
          Войти
        </button>
      </div>

    </form>
    <!-- /enter code -->

    <!-- request code -->
    <form
      class="form"
      action=""
      v-on:submit.prevent="sendForm"
      v-else
    >
      <div class="form__fields">
        <h1>Вход в приложение</h1>

        <p>
          Для старта online-игры войдите<br>
          в приложение, указав номер<br>
          мобильного телефона<br>
          в международном формате
        </p>

        <div class="form-input__wrapper">
          <input
            type="tel"
            class="form-input"
            placeholder="+7 960 125 00 00"
            minlength="3"
            v-model.trim="form.phone"
            required
          />
        </div>

        <!-- <p class="hint">
          На указанный номер будет совершён звонок<br>
          со случайного номера. Не берите трубку.<br>
          Последние 4 цифры номера &ndash; welcome-код
        </p> -->
      </div>

      <div class="form__controls">
        <vue-recaptcha
          class="recaptcha__wrapper"
          ref="reCaptcha"
          size="invisible"
          badge="inline"
          v-bind:sitekey="$options.siteKey"
          v-bind:loadRecaptchaScript="true"
          v-on:verify="onVerify"
          v-on:expired="onExpired"
        ></vue-recaptcha>

        <span
          class="ajax-loading"
          v-if="isLoading"
        ></span>
        <button
          v-else
          class="dark button"
          v-bind:class="{ inactive: !validPhone }"
        >
          Войти
        </button>
      </div>
    </form>
    <!-- /request code -->
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import Api from '../../../lib/PlayerApi';
import Toast from '../../../lib/ToastWrapper';
import Auth from '../../../lib/Auth';
// import initRecaptcha from '../../../lib/Recaptcha';
import CodeBox from '../../shared/CodeBox.vue';

const plural = (number, titles) => {
  // 0 - single, 1 - two..four, 2 - five
  const cases = [2, 0, 1, 1, 1, 2];
  const pos4 = (number % 100 > 4 && number % 100 < 20);
  const pos5 = (number % 10 < 5) ? number % 10 : 5;
  return titles[pos4 ? 2 : cases[pos5]];
};

const prettyTimeout = (seconds) => {
  if (seconds < 60) return `${seconds} ${plural(seconds, ['секунду', 'секунды', 'секунд'])}`;

  const minutes = Math.ceil(seconds / 60);
  if (minutes < 60) return `${minutes} ${plural(minutes, ['минуту', 'минуты', 'минут'])}`;

  const hours = Math.ceil(seconds / 3600);

  return `${hours} ${plural(hours, ['час', 'часа', 'часов'])}`;
};

export default {
  name: 'AuthLogin',

  props: ['data', 'meta'],

  siteKey: process.env.VUE_APP_SITE_KEY,

  components: {
    VueRecaptcha,
    CodeBox,
  },

  beforeDestroy() {
    if (this.$refs.recaptcha) {
      this.$refs.reCaptcha.reset();
    }
  },

  mounted() {
    if (this.$refs.recaptcha) {
      this.$refs.reCaptcha.reset();
    }
  },

  computed: {
    validPhone() {
      return this.form.phone.trim().length > 3;
    },

    validCode() {
      return this.form.code.trim().length === this.codeDigits;
    },
  },

  data() {
    return {
      isLoading: false,
      codePending: false,
      codeDigits: 4,
      autosendCode: true,
      form: {
        phone: '',
        code: '',
      },
    };
  },

  methods: {
    sendForm() {
      this.$refs.reCaptcha.execute();
    },

    sendCode() {
      this.isLoading = true;
      this.autosendCode = false;

      Api.auth.checkCode(this.form)
        .then(({ token }) => {
          Auth.setAuth(token);
          this.$emit('event', { event: 'auth-success' });
        })
        .catch((err) => {
          console.warn('Failed to send code', err);
          Toast.show('Код не подошел');
        })
        .then(() => {
          this.isLoading = false;
        });
    },

    /**
     * @param {string} token
     */
    onVerify(token) {
      this.isLoading = true;

      Api.auth
        .getCode({ recaptcha: token, phone: this.form.phone, skip_mfa: true })
        .then((resp) => {
          // console.log('auth-get-code->', resp);
          // Toast.show('Сейчас вам позвонят');
          this.$refs.reCaptcha.reset();

          this.codePending = true;
          this.form.code = resp.code;
        })
        .catch((err) => {
          console.warn('Failed to fetch code', err);

          this.$refs.reCaptcha.reset();

          if (err.data && err.data.code === 429) {
            // timeout error
            const timeout = parseInt(err.data.retry, 10);
            if (!Number.isNaN(timeout)) {
              Toast.show(`Повторите попытку получения кода через ${prettyTimeout(timeout)}`);
            } else {
              Toast.show('Код можно получить не чаще 1 раза в 3 минуты');
            }
          } else {
            Toast.show('Неизвестная ошибка');
          }
        })
        .then(() => {
          this.isLoading = false;

          this.sendCode();
        });
    },

    onExpired() {
      if (this.$refs.reCaptcha) {
        this.$refs.reCaptcha.reset();
      }
    },
  },
};
</script>
